module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PleaseInputToSearch":"Please input to search"},"vi":{"PleaseInputToSearch":"Gõ tên tag để tìm kiếm."}}')
  delete Component.options._Ctor
}
